import React from "react";
import Card from "../../components/card/Card";
import FormModificaMacrocategoriaController from "./components/FormModificaMacrocategoriaController";

export default function InserisciMacrocategoriaFigliaView({
                                                              id,
                                                              idClasse,
                                                              history,
                                                              translate,
                                                              formikRef,
                                                              padre,
                                                              bottoniSx,
                                                              bottoniDx,
                                                          }) {

    return (
        <Card
            icon={'fas fa-list'}
            title={"Inserisci macrocategoria figlia"}
            bottoniSx={bottoniSx}
            bottoniDx={bottoniDx}
        >
            <FormModificaMacrocategoriaController
                id={id}
                idClasse={idClasse}
                history={history}
                formikRef={formikRef}
                principale={true}
                addFiglio={true}
                padre={padre}
            />
        </Card>
    );
}